import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Background from './components/BackgroundImage';
import Navbar from './components/Navbar';
import Info from './pages/Info';
import Mint from './pages/Mint';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Web3ReactProvider } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import axios from 'axios';
const entanglerAbi = require('./entanglerAbi.json');

function App() {
  let [userNfts, setUserNfts] = useState([]);
  let [mintInProgress, setMintInProgress] = useState(false);
  let [userAccount, setUserAccount] = useState();
  let [entangler, setEntangler] = useState();
  let [signer, setSigner] = useState();
  let [nftsBeingSearchedFor, setNftsBeingSearchedFor] = useState([]);
  let [nftsToUpdate, setNftsToUpdate] = useState([]);
  let [nftsToUpdate2, setNftsToUpdate2] = useState([]);
  let [missingRoyalties, setMissingRoyalties] = useState([]);
  let [waitingUserConfirmTx, setWaitingUserConfirmTx] = useState(false);
  let [waitingMintTxConfirm, setWaitingMintTxConfirm] = useState(false);
  let [waitingRoyaltyGeneration, setWaitingRoyaltyGeneration] = useState(false);
  let [holdMetadataReqs, setHoldMetadataReqs] = useState(false);
  let [latentNfts, setLatentNfts] = useState([]);
  let [preexistingNfts, setPreexistingNfts] = useState([]);

  const entanglerAddress = '0xDC08aa5d94AC05F73DdB1F29a13C1b6e9c384980';
  const metadataServerUrl = 'https://alignlabs.io';

  const addUserNfts = (newNfts) => {
    if (typeof entangler === 'undefined') setEntangler(new ethers.Contract(entanglerAddress, entanglerAbi, signer));
    let tmpArr = [];
    for (const nft in newNfts) {
      let tmp = { id: nft, royalties: newNfts[nft], TVR: null, img: null, mandates: newNfts[nft].mandates };
      tmpArr.push([tmp]);
      setUserNfts([...userNfts, ...tmpArr]);
    }
  };

  useEffect(() => {
    for (let i = 0; i < userNfts.length; i++) {
      let nft = userNfts[i];
      if ((nft[0].TVR === null || nft[0].img === null) && !nftsBeingSearchedFor.includes(nft[0].id)) {
        setTimeout(() => { talkToMetadataServer(nft[0].id, userNfts); }, (i + 1) * 1000);
        setNftsBeingSearchedFor([...nftsBeingSearchedFor, nft[0].id]);
      }
    }
    if (nftsToUpdate.length > 0) updateNfts();
    if (latentNfts.length > 0) updateNfts2();
    pruneUserNfts();
    orderNfts();
  });

  const orderNfts = () => {
    let tmp = userNfts.map(x => x);
    let orderedIndices = [];
    for (let i = 0; i < tmp.length; i++) {
      let lowest = parseInt(tmp[i][0].id), lowestIdx = i;
      for (let j = 0; j < tmp.length; j++) {
        if ((parseInt(tmp[j][0].id) < lowest && !orderedIndices.includes(j)) || (orderedIndices.includes(lowestIdx) && !orderedIndices.includes(j))) {
          lowest = parseInt(tmp[j][0].id); lowestIdx = j;
        }
      }
      orderedIndices.push(lowestIdx);
    }
    let resArr = orderedIndices.map(i => tmp[i]);
    let needsUpdate = orderedIndices.some((idx, i) => i < orderedIndices.length - 1 && orderedIndices[i + 1] - idx !== 1);
    if (needsUpdate) setUserNfts(resArr);
  };

  const updateNfts = () => {
    if (userNfts.length > 0 && nftsToUpdate.length > 0) {
      for (let i = 0; i < nftsToUpdate.length; i++) {
        for (let k = 0; k < userNfts.length; k++) {
          if (userNfts[k][0].id == nftsToUpdate[i][0].id) {
            let tmp = [...userNfts]; tmp.splice(k, 1); tmp.push(nftsToUpdate[i]);
            let tmpU = [...nftsToUpdate]; tmpU.splice(i, 1);
            setNftsToUpdate(tmpU); break;
          }
        }
      }
    }
  };

  const updateNfts2 = () => {
    if (userNfts.length > 0 && latentNfts.length > 0) {
      for (let i = 0; i < latentNfts.length; i++) {
        for (let k = 0; k < userNfts.length; k++) {
          if (userNfts[k][0].id == latentNfts[i][0].id) {
            let tmpNft = userNfts[k][0];
            let anyNew = false;
            for (let j = 0; j < latentNfts[i][0].royalties.length; j++) {
              if (typeof tmpNft.royalties[j] === 'undefined') { anyNew = true; tmpNft.royalties[j] = latentNfts[i][0].royalties[j]; }
            }
            if (anyNew) {
              let tmpL = [...latentNfts]; tmpL.splice(i, 1);
              setNftsToUpdate([...nftsToUpdate, [tmpNft]]);
            }
            break;
          }
        }
      }
    }
  };

  const pruneUserNfts = () => {
    for (let i = 0; i < userNfts.length; i++) {
      for (let j = i + 1; j < userNfts.length; j++) {
        if (userNfts[i][0].id === userNfts[j][0].id) {
          let keep = (userNfts[i][0].TVR !== null && userNfts[i][0].img !== null) ? j : i;
          let tmp = [...userNfts]; tmp.splice(keep, 1); setUserNfts(tmp);
        }
      }
    }
  };

  async function talkToMetadataServer(nft, localUserNfts) {
    let resultsFound = false;
    for (let i = 0; i < 40; i++) {
      setTimeout(async () => {
        let currNftFromState = userNfts.find(n => n[0].id == nft)?.[0];
        if (!resultsFound && currNftFromState?.TVR === null) {
          try {
            setHoldMetadataReqs(true);
            const res = await axios.get(`${metadataServerUrl}/metadata/v0/${nft}.json`);
            let tmpRecord = localUserNfts.find(n => n[0].id == nft)?.[0];
            for (let j = 0; j < res.data.attributes.length; j++) {
              const attr = res.data.attributes[j];
              if (attr.trait_type === 'TVR') { tmpRecord.TVR = attr.value; tmpRecord.img = res.data.image; resultsFound = true; }
              if (['WATER','PEOPLE','EARTH','ATMOSPHERE'].includes(attr.trait_type)) {
                if (typeof tmpRecord.royalties[j] === 'undefined') tmpRecord.royalties[j] = attr.value;
                resultsFound = true;
              }
              setHoldMetadataReqs(false);
              if (j === res.data.attributes.length - 1 && resultsFound) await setNftsToUpdate([...nftsToUpdate, [tmpRecord]]);
            }
          } catch(e) { setHoldMetadataReqs(false); }
        }
      }, (i + 1) * 30000);
    }
  }

  function getLibrary(provider) { return new Web3Provider(provider); }
  const addNftsWithoutRoyalties = (nftsToAdd) => setMissingRoyalties([...missingRoyalties, ...nftsToAdd]);

  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Router>
        <div className="App">
          <div className="main-container">
            <Header />
            <Routes>
              <Route path="/" element={<Info />} />
              <Route path="/info" element={<Info />} />
              <Route path="/mint" element={
                <Mint mintInProgress={mintInProgress}
                  userNfts={userNfts}
                  waitingForUserToConfirm={waitingUserConfirmTx}
                  waitingForTxToConfirm={waitingMintTxConfirm}
                  waitingForRoyaltyGeneration={waitingRoyaltyGeneration}
                  missingRoyalties={missingRoyalties}
                  latentNfts
                  setLatentNfts={setLatentNfts}
                  onNewNfts={addUserNfts}
                  onSetNftsToUpdate2={setNftsToUpdate2}
                  onSetUserAccount={setUserAccount}
                  onSetEntangler={setEntangler}
                  onSetSigner={setSigner}
                  onMintInProgress={setMintInProgress}
                  onMissingRoyalties={addNftsWithoutRoyalties}
                  onWaitingForUserToConfirm={setWaitingUserConfirmTx}
                  onWaitingForTxToConfirm={setWaitingMintTxConfirm}
                  onWaitingForRoyaltyGeneration={setWaitingRoyaltyGeneration}
                  preexistingNfts={preexistingNfts}
                  setPreexistingNfts={setPreexistingNfts} />
              } />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </Web3ReactProvider>
  );
}

export default App;
